/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationRequest,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationResponse,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsPathParams,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels400,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels401,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels500,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels } from "../../clients/individualPaymentOperationsController/postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels.ts";

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationKey =
  () =>
    [
      {
        url: "/api/v1/individualpayment/financial-people/:financialPersonId/parcels",
      },
    ] as const;

export type PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationKey =
  ReturnType<
    typeof postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationKey
  >;

export function postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey =
    postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationKey();
  return mutationOptions<
    PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels400
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels401
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels500
    >,
    {
      financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsPathParams["financialPersonId"];
      data?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ financialPersonId, data }) => {
      return postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels(
        financialPersonId,
        data,
        config,
      );
    },
  });
}

/**
 * @description Cria a parcela com Nosso Número gerado no banco do plano (com verificação de unicidade); 'multiple' gera cópias com +1 mês e +1 número cada, com serial próprio. Rejeita número de parcela duplicado (mesmo tipo, não cancelada). Migrado do legado IndividualPayment/CreateParcel POST. **(Requer Authorization para autenticação)**
 * @summary Cria parcela manual no plano (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId/parcels}
 */
export function usePostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels400
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels401
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels500
      >,
      {
        financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsPathParams["financialPersonId"];
        data?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationKey();

  const baseOptions =
    postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels400
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels401
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels500
      >,
      {
        financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsPathParams["financialPersonId"];
        data?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationRequest;
      },
      TContext
    >;

  return useMutation<
    PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels400
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels401
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels500
    >,
    {
      financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsPathParams["financialPersonId"];
      data?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels400
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels401
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcels500
    >,
    {
      financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsPathParams["financialPersonId"];
      data?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsMutationRequest;
    },
    TContext
  >;
}
